import { useCallback } from 'react'

import { getProfile } from 'integration/resources/user/requests'
import { useSetAuthAtom } from 'src/store/auth'
import { useSetTokenAtom } from 'src/store/token'
import { LogEventUserId, LogEventUserProperties } from 'src/utils/logEvents'
import { returnDescriptionSegment } from 'src/utils/users'

export const useAuthSSOScreen = () => {
  const setAuthAtom = useSetAuthAtom()

  const setTokenAuthAtom = useSetTokenAtom()

  const handleSSOLogin = useCallback(
    async (token: string) => {
      try {
        const response = await getProfile(token)

        const userData = response.data as any

        setAuthAtom({
          auth: { token },
          user: userData.data
        })

        setTokenAuthAtom(token)

        LogEventUserId(`${userData.data?.std_code}`)

        LogEventUserProperties({
          business_code: returnDescriptionSegment(userData.data?.business_code),
          std_code: `${userData.data?.std_code}`,
          occupation: `${userData.data?.occupation}`
        })
      } catch (err) {
        console.error('Erro no login SSO:', err)
      }
    },
    [setAuthAtom, setTokenAuthAtom]
  )

  return { handleSSOLogin }
}
